import type { z } from "zod";

import type { customCardSchema } from "@/schemas";

import { Inset } from "./inset";
import { LinkNoMedia } from "./link-no-media";
import { Vertical } from "./vertical";
import { WithLeftBorder } from "./with-left-border";
import { WithLink } from "./with-link";
import { WithTimer } from "./with-timer";

export function CustomCard({
  className,
  ...props
}: z.infer<typeof customCardSchema> & { className?: string }) {
  if (props?.variant === "inset") {
    return <Inset className={className} {...props} />;
  }

  if (props?.variant === "withLink") {
    return <WithLink className={className} {...props} />;
  }

  if (props?.variant === "linkNoMedia") {
    return <LinkNoMedia className={className} {...props} />;
  }

  if (props?.variant === "withTimer") {
    return <WithTimer className={className} {...props} />;
  }

  if (props?.variant === "vertical") {
    return <Vertical className={className} {...props} />;
  }

  if (props?.variant === "withLeftBorder") {
    return <WithLeftBorder className={className} {...props} />;
  }

  return null;
}
